import { h, render, Component } from 'preact';

class TxrCookieBanner extends Component {

    state = {
        cookiePolicyId: 'txrCookiePolicy',
        isShow: false
    }
    getCookiePolicyKey() {
        return `${this.state.cookiePolicyId}`
    }
    componentDidMount() {
        setTimeout(() => {
            const policy = localStorage.getItem(this.getCookiePolicyKey()); //all, reject
            if(!policy || policy === 'undefined') {
                this.setState({ isShow: true });
                this.updateCookies(true);
            } else {
                this.setState({ isShow: false });
                this.updateCookies(policy === 'all')
            }
            
            if(this.props.triggerIds) {
                const triggerIds = this.props.triggerIds.split(',');
                Array.from(triggerIds).forEach((triggerId) => {
                    const el = document.getElementById(triggerId);
                    el.onclick = () => {
                        this.show();
                    };
                });
            }
        }, 1000);
    }
    submit(policy) {
        this.setState({ isShow: false });
        if(!policy) {
            return;
        }
        const prevPolicy = localStorage.getItem(this.getCookiePolicyKey());
        localStorage.setItem(this.getCookiePolicyKey(), policy);
        if((!prevPolicy || prevPolicy === 'undefined' || prevPolicy === 'all') && policy === 'reject') {
            location.reload();
        } else {
            this.updateCookies(policy === 'all')
        }
    }
    show = () => {
        this.setState({ isShow: true });
    }
    updateCookies(allow) {
        if(allow) {
              const header = document.getElementsByTagName('head')[0];
              const body = document.getElementsByTagName('body')[0];
              const lastScript = body.querySelector('#txr-scripts-placeholder');
            
              /*Google Tag Manager*/
              gtag('consent', 'update', {
                ad_user_data: 'granted',
                ad_personalization: 'granted',
                ad_storage: 'granted',
                analytics_storage: 'granted'
              });
              const gtmScript = document.createElement('script');
              gtmScript.text = `
               (function (w, d, s, l, i) {
                w[l] = w[l] || []; w[l].push({
                    'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                }); var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', 'GTM-NJ5GZ2M');
              `;
              header.appendChild(gtmScript);
              const gtmnoScript = document.createElement('noscript');
              gtmnoScript.text = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NJ5GZ2M" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
              body.insertBefore(gtmnoScript, body.firstChild);
              /*Bing*/ 
            const bingScript = document.createElement('script');
            bingScript.text = '(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"11028308"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");'
            header.appendChild(bingScript);
            /*linked in*/
            const linkedScript = document.createElement('script');
            linkedScript.text = `
                _linkedin_partner_id = "2545178";
                window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
                window._linkedin_data_partner_ids.push(_linkedin_partner_id);`
            body.insertBefore(linkedScript, lastScript);
            const linkedScript2 = document.createElement('script');
            linkedScript2.text = `
                    (function(l) {
                        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
                        window.lintrk.q=[]}
                        var s = document.getElementsByTagName("script")[0];
                        var b = document.createElement("script");
                        b.type = "text/javascript";b.async = true;
                        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
                        s.parentNode.insertBefore(b, s);})(window.lintrk);
            `
            body.insertBefore(linkedScript2, lastScript);
            const linkedScript3 = document.createElement('noscript');
            linkedScript3.text  = `
                   <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=2545178&fmt=gif" />
            `
            body.insertBefore(linkedScript3, lastScript);
            /* Twitter universal website tag code */
            const twitterScript = document.createElement('script');
            twitterScript.text = `
                    !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
                },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
                a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
                // Insert Twitter Pixel ID and Standard Event data below
                twq('init','o75e9');
                twq('track','PageView');
            `
            body.insertBefore(twitterScript, lastScript);

            /*Meta Pixel Code*/
            const metaScript = document.createElement('script');
            metaScript.text = `
              !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '1061784951250288');
                fbq('track', 'PageView');
            `
            body.insertBefore(metaScript, lastScript);
            const metaNoScript = document.createElement('noscript');
            metaNoScript.text  = `
                   <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1061784951250288&ev=PageView&noscript=1"/>
            `
            body.insertBefore(metaNoScript, lastScript);
            /*G2*/  
            const g2Script = document.createElement('script');
            g2Script.text = `
              (function (c, p, d, u, id, i) {
                id = ''; // Optional Custom ID for user in your system
                u = 'https://tracking.g2crowd.com/attribution_tracking/conversions/' + c + '.js?p=' + encodeURI(p) + '&e=' + id;
                i = document.createElement('script');
                i.type = 'application/javascript';
                i.async = true;
                i.src = u;
                d.getElementsByTagName('head')[0].appendChild(i);
                }("1006300", document.location.href, document));
            `
            body.insertBefore(g2Script, lastScript);
             
            /*Start of HubSpot Embed Code*/  
              const hubspotScript = document.createElement('script');
              hubspotScript.id='hs-script-loader'
              hubspotScript.async = true;
              hubspotScript.type = 'text/javascript';
              hubspotScript.src="//js.hs-scripts.com/6306809.js"
              body.insertBefore(g2Script, lastScript);
              
            /*Clarity*/
            const clarityScript = document.createElement('script');
            clarityScript.text = `
              (function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i+"?ref=gtm2";y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","9n84tikogb");
            `
            body.insertBefore(clarityScript, lastScript);
        }
    }
    render() {
        return (
            this.state.isShow && <div class="txr-cookie-banner">
                    <i class="fal fa-times banner-close-icon" onClick={() => this.submit()}></i>
                    <img class="banner-image" src="/images/navigation/cookie-banner-icon.svg" alt="cookie icon"></img>
                    <div class="banner-text">
                      We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic.<br/>
                      By clicking “Accept All”, you consent to our use of cookies in accordance with our <a class="txr-text__link" href="/cookie-policy">Cookie Notice</a>.<br/>
                      By browsing this site, you accept the <a class="txr-text__link" href="/privacy-policy">Privacy Notice</a>.
                    </div>
                    <div class="banner-bottom">
                        <button class="txr-button txr-primary-button" type="button" onClick={() => this.submit('all')}>
                            <span class="txr-button__content"> ACCEPT ALL
                                <i class="txr-button__angle-icon fal fa-angle-right"></i>
                            </span>
                        </button>
                        <button class="txr-button txr-action-button" type="button"  onClick={() => this.submit('reject')}>
                            <span class="txr-button__content">REJECT NON ESSENTIAL COOKIES
                                <i class="txr-button__angle-icon fal fa-angle-right"></i>
                            </span>
                        </button>
                    </div>
            </div>
        )
    }
}

export default TxrCookieBanner;